export default __webpack_public_path__ + "static/media/logoPsd.df32308b.png";